import { useState, useEffect } from "react";
import Button from "../../components/button";
import CardContainer from "../../components/card_container";
import Input from "../../components/input";
import Select from "../../components/select";
import SelectMultiple from "../../components/select_multiple";
import "./style/fabric.scss";
import UseFormStyleOptions from "./hook/hookForm";
import LoadingModal from "../../components/loading_modal";
import { axios } from "../../helpers";
import { useSelector } from "react-redux";
import { loginData } from "../../stores/auth";

const EditStyleOptionsPage = () => {
  const {
    isLoadingPut,
    form,
    handleChange,
    handleSubmit,
  } = UseFormStyleOptions({
    type: "put",
  });

  let [parts, setParts] = useState([]);
  let [fabrics, setFabrics] = useState([]);
  const dataLogin = useSelector(loginData);

  const getStyleParts = async () => {
    await axios
      .get("/v1/style_options/parts", {
        headers: { Authorization: `Bearer ${dataLogin.data.token}` },
      })
      .then((res) => {
        let tmp = [];
        res.data.data.map((item) => {
          tmp.push({ value: item._id, label: `${item.name} (${item.type})` });
        });
        setParts([{ value: "", label: "-- Select Style Part --" }, ...tmp]);
      });
  };

  const getFabrics = async () => {
    await axios
      .get("/v1/style_options/fabrics", {
        headers: { Authorization: `Bearer ${dataLogin.data.token}` },
      })
      .then((res) => {
        let tmp = [];
        res.data.data.map((item) => {
          tmp.push({ value: item._id, label: item.fabric_name });
        });
        setFabrics([{ value: "", label: "-- Select Fabric --" }, ...tmp]);
      });
  };

  useEffect(() => {
    getStyleParts();
    getFabrics();
  }, []);

  return (
    <>
      <CardContainer
        title={"Edit Data"}
        isBack={true}
        children={
          <form className="" onSubmit={handleSubmit}>
            <div className="form-fabric">
              <div className="expanded-y">
                <Input
                  style={{ width: "100%" }}
                  id="name"
                  onChange={handleChange}
                  label="Style Option Name"
                  placeholder="Input Style Option name"
                  required={true}
                  value={form.name || ""}
                />
                <Input
                  style={{ width: "100%" }}
                  id="frontName"
                  onChange={handleChange}
                  label="Front Name"
                  placeholder="Input Front Name"
                  value={form.frontName || ""}
                />
                <Input
                  style={{ width: "100%" }}
                  id="backName"
                  onChange={handleChange}
                  label="Back Name"
                  placeholder="Input Back Name"
                  value={form.backName || ""}
                />
                <Input
                  style={{ width: "100%" }}
                  id="foldedName"
                  onChange={handleChange}
                  label="Folded Name"
                  placeholder="Input Folded Name"
                  value={form.foldedName || ""}
                />
                <SelectMultiple
                  label="Fabric"
                  id="fabric"
                  value={form.fabric}
                  onChange={handleChange}
                  required={true}
                  options={fabrics}
                  style={{ width: "100%" }}
                />
                <Select
                  label="Part of"
                  id="partId"
                  value={form.partId}
                  onChange={handleChange}
                  required={true}
                  options={parts}
                  style={{ width: "100%" }}
                />
                <Input
                  style={{ width: "100%" }}
                  id="icon"
                  onChange={handleChange}
                  label="Icon Path / URL"
                  placeholder="Input Icon Path or URL (optional)"
                  value={form.icon || ""}
                />
              </div>
              <hr style={{ width: "100%" }} />
              <div className="footer-forms">
                <Button
                  type="button"
                  className="btn-outline-primary"
                  style={{ marginRight: "8px" }}
                  title="Cancel"
                  onClick={() => window.history.back()}
                />
                <Button type="submit" className="btn-primary" title="Save" />
              </div>
            </div>
          </form>
        }
      />
      <LoadingModal isLoading={isLoadingPut} />
    </>
  );
};

export default EditStyleOptionsPage;
